module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main